<template>
  <span>
    <v-card class="my-1" elevation="0">
      <v-card-title>
        <h5>ISFP — Série Temporal (12 Meses)</h5>
      </v-card-title>
      <v-card-text>
        <div
          v-if="loading"
          class="d-flex align-center justify-center"
          style="height: 320px;"
        >
          <v-progress-circular indeterminate color="primary" size="32" />
        </div>
        <div v-else ref="chartContainer" style="width: 100%; height: 320px;" />
        <div
          v-if="serieIsfp.length === 0 && !loading"
          class="text-center grey--text py-4"
        >
          Sem dados para exibição
        </div>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import { highchartsColors } from "@/constants/highchartsColors";
HighchartsNoData(Highcharts);

export default {
  name: "DashboardIsfpPsfpSerieTemporalIsfpTendencia",
  props: {
    serieIsfp: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    chartInstance: null,
  }),
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
  methods: {
    formatarCompetencia(competencia) {
      const [ano, mes] = competencia.split("-");
      const meses = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ];
      return `${meses[parseInt(mes) - 1]}/${ano.slice(2)}`;
    },

    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const container = this.$refs.chartContainer;
      if (!container || this.serieIsfp.length === 0) return;

      const categorias = this.serieIsfp.map((p) =>
        this.formatarCompetencia(p.competencia),
      );
      const dadosAnual = this.serieIsfp.map((p) => p.isfp_anual);

      this.chartInstance = Highcharts.chart(container, {
        chart: { type: "column", style: { fontFamily: "inherit" } },
        title: { text: null },
        xAxis: { categories: categorias, crosshair: true },
        yAxis: {
          title: { text: null },
          labels: {
            formatter() {
              return this.value + "%";
            },
          },
        },
        tooltip: {
          shared: true,
          formatter() {
            let s = `<b>${this.x}</b><br/>`;
            this.points.forEach((point) => {
              s += `${point.series.name}: <b>${point.y}%</b><br/>`;
            });
            return s;
          },
        },
        legend: {
          enabled: true,
          align: "left",
          verticalAlign: "bottom",
          symbolWidth: 28,
        },
        plotOptions: {
          column: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter() {
                return `${this.y}%`;
              },
            },
          },
          series: {
            animation: false,
          },
        },
        series: [
          {
            name: "ISFP",
            data: dadosAnual,
            color: highchartsColors[0],
          },
        ],
        credits: { enabled: false },
        lang: { noData: "Sem dados para exibição" },
        noData: { style: { color: "#999", fontSize: "14px" } },
      });
    },
  },
  watch: {
    loading(val) {
      if (!val && this.serieIsfp.length > 0) {
        this.$nextTick(() => this.renderChart());
      }
    },
    serieIsfp(val) {
      if (val.length > 0 && !this.loading) {
        this.$nextTick(() => this.renderChart());
      }
    },
  },
};
</script>

<style scoped></style>
